module.exports = __webpack_public_path__ + "img/ajax_code.42a8be18.png";